<template functional>
  <header :class="{'header--preview': props.isPreviewPage }">
    <div class="flex__container">

      <transition name="fade" appear>
        <div class="back__container" :key="props.title">
          <button
            v-if="props.hasStartCtrl"
            class="button button--ctrl back"
            @click.stop="listeners.back"
          />
        </div>
    </transition>

      <div class="content">
        <router-link
          class="content__logo"
          tag="figure"
          to="/game"
        >
          <img
            src="../../../assets/logo.png"
            alt="logo"
          />
        </router-link>

        <transition name="fade" appear mode="out-in">
          <h2 class="content__title" :key="props.title">
            {{ props.title }}
          </h2>
        </transition>
      </div>

      <transition name="fade" appear>
        <div class="control" :key="props.title">
          <button
            v-if="props.displayModiface"
            class="button button--ctrl button--preview"
            @click.stop="listeners.toPreview"
          />

          <component v-if="props.displayLanguage" :is="injections.components.LanguageSelector" />
      </div>
    </transition>
    </div>
  </header>
</template>

<script>
import LanguageSelector from '@/components/ui/LanguageSelector'

export default {
  inject: {
    components: {
      default: {
        LanguageSelector
      }
    }
  },
  props: {
    title: {
      type: String
    },
    hasStartCtrl: {
      type: Boolean
    },
    hasModiface: {
      type: Boolean
    },
    displayModiface: {
      type: Boolean
    },
    displayLanguage: {
      type: Boolean
    },
    isPreviewPage: {
      type: Boolean
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../style/css/screens.scss';
header {
  display: flex;
  justify-content: center;
}

.header {
  &--preview {

    .content {
      &__logo {
        max-width: 95%;
        margin: 0;
        flex: 1;
        display: flex;
        justify-content: center;
      }
      &__title {
        display: none;
      }
    }
  }
}
.flex__container {
  flex: 0 1 90%;
  display: grid;
  grid-template-columns: .5fr 3fr .5fr;
  grid-template-areas: "back content control";

  @media screen and (max-width: $handheld) {
    flex-basis: 95%;
    grid-template-columns: .5fr 2fr .5fr;
  }
  @media screen and (orientation: landscape) and (max-height: $handheld) {
    grid-template-columns: .5fr 1.2fr .5fr;
    flex-basis: 95%;
  }
}

.back {
  &__container {
    grid-area: back;

    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.content {
  grid-area: content;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__logo {
    max-width: 350px;
    margin-bottom: 20px;

      @media screen and (max-width: $handheld) {
        max-width: 220px;
      }
      @media screen and (orientation: landscape) and (max-height: $handheld) {
        margin-bottom: 0;
        width: 65%;
      }

    & > img {
      object-fit: contain;
      max-width: inherit;
    }
  }

  &__title {
    font-size: 2rem;
    text-transform: uppercase;
    text-align: center;

    @media screen and (max-width: $handheld) {
      font-size: 1.2rem;
    }

    @media screen and (orientation: landscape) and (max-height: $handheld) {
      font-size: 1.2rem;
    }
  }
}

.control {
  grid-area: control;

  display: flex;
  justify-content: center;
  align-items: center;
}

.button {
  font-size: 24px;
  font-family: 'Gotham';
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: transform 0.15s linear;
  position: initial;
  border: 0;

  &--ctrl {
    background-color: white;
    box-shadow: 2px 4px 7px rgba(0, 0, 0, 0.25);
    border-radius: 50%;
    height: 85px;
    width: 85px;
    padding: 0;
    margin: 0;

    @media screen and (max-width: $handheld) {
      width: 50px;
      height: 50px;
      background-size: 60%;
    }

    @media screen and (orientation: landscape) and (max-height: $handheld) {
      width: 50px;
      height: 50px;
      background-size: 60%;
    }
  }

  &#{&}--preview {
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('../../../assets/modiface.png');
  }

  &#{&}--product {
    &:before {
      content: '';
      mask-image: url('../../../assets/icons/lipstick.svg');
      mask-repeat: no-repeat;
      mask-position: center;
      mask-size: 66%;
      background-color: hsla(0, 0%, 23%, 1);
      display: block;
      height: 100%;
    }
  }
}

.fade {
  &-enter, &-leave-to {
    opacity: 0;
  }

  &-enter-active, &-leave-active {
    transition: all .5s ease-out;
  }

  &-enter-active {
    transition-delay: .5s;
  }
}
</style>
